import React from 'react';

import AgDateFilterLayout from './AgDateFilterLayout';

import { AgDateFilterProps } from './types';
import useAgDateFilterCore from './hooks/useAgDateFilterCore';

const AgDateFilterFE: React.FC<AgDateFilterProps> = ({
  defaultOption,
  model,
  onModelChange,
  format,
  buttons,
  colDef,
}) => {
  const core = useAgDateFilterCore({
    defaultOption,
    model,
    onModelChange,
    field: colDef.field,
  });

  return <AgDateFilterLayout format={format} buttons={buttons} {...core} />;
};

export default AgDateFilterFE;
